/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [快递费率表-快递公司↗](http://yapi.yishou.com/project/128/interface/api/33294) 的 **请求配置**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @标签 `快递优选一期`
 * @请求头 `POST /erp/WavePickingShipping/rateShippingCompany`
 * @更新时间 `2022-03-29 11:08:30`
 */
const rateShippingCompanyRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePickingShipping/rateShippingCompany",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: { type: "object", required: [], properties: {} },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            cpid: { type: "string", description: '"1"' },
            shipping_company: { type: "string", description: '"圆通"' },
          },
          additionalProperties: false,
        },
        description:
          '[{"cpid":"1","shipping_company":"圆通"},{"cpid":"2","shipping_company":"申通"},{"cpid":"3","shipping_company":"顺丰"},{"cpid":"4","shipping_company":"韵达"},{"cpid":"5","shipping_company":"中通"},{"cpid":"9","shipping_company":"百世"},{"cpid":"10","shipping_company":"EMS"},{"cpid":"11","shipping_company":"丰网速运"},{"cpid":"12","shipping_company":"邮政快递包裹"},{"cpid":"13","shipping_company":"天天快递"},{"cpid":"14","shipping_company":"极兔"}]',
      },
    },
    additionalProperties: false,
  },
  requestFunctionName: "rateShippingCompany",
  extraInfo: {},
};
/**
 * 接口 [快递费率表-快递公司↗](http://yapi.yishou.com/project/128/interface/api/33294) 的 **请求函数**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @标签 `快递优选一期`
 * @请求头 `POST /erp/WavePickingShipping/rateShippingCompany`
 * @更新时间 `2022-03-29 11:08:30`
 */
export const rateShippingCompany = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(rateShippingCompanyRequestConfig, requestData),
    ...args
  );
};
rateShippingCompany.requestConfig = rateShippingCompanyRequestConfig;
/**
 * 接口 [快递费率表-导入↗](http://yapi.yishou.com/project/128/interface/api/33295) 的 **请求配置**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @标签 `快递优选一期`
 * @请求头 `POST /erp/WavePickingShipping/rateImport`
 * @更新时间 `2022-03-31 09:56:32`
 */
const rateImportRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePickingShipping/rateImport",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ["file"],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["file", "cpid", "stock_storehouse_id", "file"],
    properties: {
      file: { type: "string", description: "" },
      cpid: { type: "string", description: "快递公司id" },
      stock_storehouse_id: { type: "string", description: "仓库id" },
    },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: { file: { type: "string" } },
    additionalProperties: false,
  },
  requestFunctionName: "rateImport",
  extraInfo: {},
};
/**
 * 接口 [快递费率表-导入↗](http://yapi.yishou.com/project/128/interface/api/33295) 的 **请求函数**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @标签 `快递优选一期`
 * @请求头 `POST /erp/WavePickingShipping/rateImport`
 * @更新时间 `2022-03-31 09:56:32`
 */
export const rateImport = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(rateImportRequestConfig, requestData), ...args);
};
rateImport.requestConfig = rateImportRequestConfig;
/**
 * 接口 [获取所有区域 ， 支持模糊查询↗](http://yapi.yishou.com/project/128/interface/api/33307) 的 **请求配置**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/getShippingAreaList`
 * @更新时间 `2022-03-29 11:54:49`
 */
const getShippingAreaListRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePickingShipping/getShippingAreaList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["region_name"],
    properties: { region_name: { type: "string" } },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            value_id: { type: "string", description: '"6"' },
            value_name: { type: "string", description: '"广东省"' },
            child: {
              type: "array",
              items: {
                type: "object",
                properties: {
                  value_id: { type: "string", description: '"95"' },
                  value_name: { type: "string", description: '"中山市"' },
                  child: {
                    type: "array",
                    items: {
                      type: "object",
                      properties: {
                        value_id: { type: "string", description: '"3508"' },
                        value_name: { type: "string", description: '"神湾镇"' },
                      },
                      additionalProperties: false,
                    },
                    description:
                      '[{"value_id":"3508","value_name":"神湾镇"},{"value_id":"3507","value_name":"大涌镇"},{"value_id":"3506","value_name":"板芙镇"},{"value_id":"3505","value_name":"三乡镇"},{"value_id":"3504","value_name":"南朗镇"},{"value_id":"3503","value_name":"阜沙镇"},{"value_id":"3502","value_name":"南头镇"},{"value_id":"3501","value_name":"横栏镇"},{"value_id":"3500","value_name":"三角镇"},{"value_id":"3499","value_name":"港口镇"},{"value_id":"3498","value_name":"坦洲镇"},{"value_id":"3497","value_name":"沙溪镇"},{"value_id":"3496","value_name":"古镇镇"},{"value_id":"3495","value_name":"东升镇"},{"value_id":"3494","value_name":"东凤镇"},{"value_id":"3493","value_name":"民众镇"},{"value_id":"3492","value_name":"黄圃镇"},{"value_id":"3491","value_name":"小榄镇"},{"value_id":"3490","value_name":"南区街道"},{"value_id":"3489","value_name":"火炬开发区街道"},{"value_id":"3488","value_name":"石岐区街道"},{"value_id":"3414","value_name":"坦州"},{"value_id":"3412","value_name":"其他"},{"value_id":"849","value_name":"五桂山街道"},{"value_id":"848","value_name":"中山港街道"},{"value_id":"847","value_name":"环城街道"},{"value_id":"846","value_name":"西区街道"},{"value_id":"845","value_name":"东区街道"},{"value_id":"844","value_name":"石岐街道"}]',
                  },
                },
                additionalProperties: false,
              },
              description:
                '[{"value_id":"95","value_name":"中山市","child":[{"value_id":"3508","value_name":"神湾镇"},{"value_id":"3507","value_name":"大涌镇"},{"value_id":"3506","value_name":"板芙镇"},{"value_id":"3505","value_name":"三乡镇"},{"value_id":"3504","value_name":"南朗镇"},{"value_id":"3503","value_name":"阜沙镇"},{"value_id":"3502","value_name":"南头镇"},{"value_id":"3501","value_name":"横栏镇"},{"value_id":"3500","value_name":"三角镇"},{"value_id":"3499","value_name":"港口镇"},{"value_id":"3498","value_name":"坦洲镇"},{"value_id":"3497","value_name":"沙溪镇"},{"value_id":"3496","value_name":"古镇镇"},{"value_id":"3495","value_name":"东升镇"},{"value_id":"3494","value_name":"东凤镇"},{"value_id":"3493","value_name":"民众镇"},{"value_id":"3492","value_name":"黄圃镇"},{"value_id":"3491","value_name":"小榄镇"},{"value_id":"3490","value_name":"南区街道"},{"value_id":"3489","value_name":"火炬开发区街道"},{"value_id":"3488","value_name":"石岐区街道"},{"value_id":"3414","value_name":"坦州"},{"value_id":"3412","value_name":"其他"},{"value_id":"849","value_name":"五桂山街道"},{"value_id":"848","value_name":"中山港街道"},{"value_id":"847","value_name":"环城街道"},{"value_id":"846","value_name":"西区街道"},{"value_id":"845","value_name":"东区街道"},{"value_id":"844","value_name":"石岐街道"}]}]',
            },
          },
          additionalProperties: false,
        },
        description:
          '[{"value_id":"6","value_name":"广东省","child":[{"value_id":"95","value_name":"中山市","child":[{"value_id":"3508","value_name":"神湾镇"},{"value_id":"3507","value_name":"大涌镇"},{"value_id":"3506","value_name":"板芙镇"},{"value_id":"3505","value_name":"三乡镇"},{"value_id":"3504","value_name":"南朗镇"},{"value_id":"3503","value_name":"阜沙镇"},{"value_id":"3502","value_name":"南头镇"},{"value_id":"3501","value_name":"横栏镇"},{"value_id":"3500","value_name":"三角镇"},{"value_id":"3499","value_name":"港口镇"},{"value_id":"3498","value_name":"坦洲镇"},{"value_id":"3497","value_name":"沙溪镇"},{"value_id":"3496","value_name":"古镇镇"},{"value_id":"3495","value_name":"东升镇"},{"value_id":"3494","value_name":"东凤镇"},{"value_id":"3493","value_name":"民众镇"},{"value_id":"3492","value_name":"黄圃镇"},{"value_id":"3491","value_name":"小榄镇"},{"value_id":"3490","value_name":"南区街道"},{"value_id":"3489","value_name":"火炬开发区街道"},{"value_id":"3488","value_name":"石岐区街道"},{"value_id":"3414","value_name":"坦州"},{"value_id":"3412","value_name":"其他"},{"value_id":"849","value_name":"五桂山街道"},{"value_id":"848","value_name":"中山港街道"},{"value_id":"847","value_name":"环城街道"},{"value_id":"846","value_name":"西区街道"},{"value_id":"845","value_name":"东区街道"},{"value_id":"844","value_name":"石岐街道"}]}]}]',
      },
    },
    additionalProperties: false,
  },
  requestFunctionName: "getShippingAreaList",
  extraInfo: {},
};
/**
 * 接口 [获取所有区域 ， 支持模糊查询↗](http://yapi.yishou.com/project/128/interface/api/33307) 的 **请求函数**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/getShippingAreaList`
 * @更新时间 `2022-03-29 11:54:49`
 */
export const getShippingAreaList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getShippingAreaListRequestConfig, requestData),
    ...args
  );
};
getShippingAreaList.requestConfig = getShippingAreaListRequestConfig;
/**
 * 接口 [物流联通表,获取列表↗](http://yapi.yishou.com/project/128/interface/api/33308) 的 **请求配置**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/getWavePickingShippingConnectList`
 * @更新时间 `2022-03-29 11:56:15`
 */
const getWavePickingShippingConnectListRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePickingShipping/getWavePickingShippingConnectList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["region_id", "origin_id", "page", "pageSize", "is_excel"],
    properties: {
      region_id: { type: "string", description: "地区id" },
      origin_id: { type: "string", description: "仓区id" },
      page: { type: "string", description: "页码" },
      pageSize: { type: "string", description: "每页加载数量" },
      is_excel: {
        type: "string",
        description: "是否导出\t默认=0 ， 1=是 0=否",
      },
    },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            province_region_id: { type: "string", description: '"6"' },
            city_region_id: { type: "string", description: '"95"' },
            area_region_id: { type: "string", description: '"3508"' },
            whole_name: {
              type: "string",
              description: '"广东省/中山市/神湾镇"',
            },
            shippingCompanyStatus: {
              type: "array",
              items: {
                type: "object",
                properties: {
                  cpid: { type: "string", description: '"1"' },
                  shipping_company: { type: "string", description: '"圆通"' },
                  status: { type: "integer", description: "1" },
                  update_admin: { type: "string", description: '"刘继明杭州"' },
                  updated_at: {
                    type: "string",
                    description: '"2022-03-26 18:22:23"',
                  },
                  updated_time: { type: "integer", description: "1648290143" },
                  table_pre: { type: "string", description: '"圆通_1"' },
                },
                additionalProperties: false,
              },
              description:
                '[{"cpid":"1","shipping_company":"圆通","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:23","updated_time":1648290143,"table_pre":"圆通_1"},{"cpid":"2","shipping_company":"申通","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:27","updated_time":1648290147,"table_pre":"申通_2"},{"cpid":"3","shipping_company":"顺丰","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:29","updated_time":1648290149,"table_pre":"顺丰_3"},{"cpid":"4","shipping_company":"韵达","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:32","updated_time":1648290152,"table_pre":"韵达_4"},{"cpid":"5","shipping_company":"中通","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:34","updated_time":1648290154,"table_pre":"中通_5"},{"cpid":"8","shipping_company":"其他","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:50","updated_time":1648290170,"table_pre":"其他_8"},{"cpid":"9","shipping_company":"百世","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:53","updated_time":1648290173,"table_pre":"百世_9"},{"cpid":"10","shipping_company":"EMS","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:23:01","updated_time":1648290181,"table_pre":"EMS_10"},{"cpid":"11","shipping_company":"丰网速运","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:30:25","updated_time":1648290625,"table_pre":"丰网速运_11"},{"cpid":"12","shipping_company":"邮政快递包裹","status":0,"update_admin":"","updated_at":"","updated_time":0,"table_pre":"邮政快递包裹_12"},{"cpid":"13","shipping_company":"天天快递","status":0,"update_admin":"","updated_at":"","updated_time":0,"table_pre":"天天快递_13"},{"cpid":"14","shipping_company":"极兔","status":0,"update_admin":"","updated_at":"","updated_time":0,"table_pre":"极兔_14"}]',
            },
            update_admin: { type: "string", description: '"刘继明杭州"' },
            updated_at: {
              type: "string",
              description: '"2022-03-26 18:30:25"',
            },
            圆通_1: { type: "integer", description: "1" },
            申通_2: { type: "integer", description: "1" },
            顺丰_3: { type: "integer", description: "1" },
            韵达_4: { type: "integer", description: "1" },
            中通_5: { type: "integer", description: "1" },
            其他_8: { type: "integer", description: "1" },
            百世_9: { type: "integer", description: "1" },
            EMS_10: { type: "integer", description: "1" },
            丰网速运_11: { type: "integer", description: "1" },
            邮政快递包裹_12: { type: "integer" },
            天天快递_13: { type: "integer" },
            极兔_14: { type: "integer" },
          },
          additionalProperties: false,
        },
        description:
          '[{"province_region_id":"6","city_region_id":"95","area_region_id":"3508","whole_name":"广东省/中山市/神湾镇","shippingCompanyStatus":[{"cpid":"1","shipping_company":"圆通","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:23","updated_time":1648290143,"table_pre":"圆通_1"},{"cpid":"2","shipping_company":"申通","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:27","updated_time":1648290147,"table_pre":"申通_2"},{"cpid":"3","shipping_company":"顺丰","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:29","updated_time":1648290149,"table_pre":"顺丰_3"},{"cpid":"4","shipping_company":"韵达","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:32","updated_time":1648290152,"table_pre":"韵达_4"},{"cpid":"5","shipping_company":"中通","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:34","updated_time":1648290154,"table_pre":"中通_5"},{"cpid":"8","shipping_company":"其他","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:50","updated_time":1648290170,"table_pre":"其他_8"},{"cpid":"9","shipping_company":"百世","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:22:53","updated_time":1648290173,"table_pre":"百世_9"},{"cpid":"10","shipping_company":"EMS","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:23:01","updated_time":1648290181,"table_pre":"EMS_10"},{"cpid":"11","shipping_company":"丰网速运","status":1,"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:30:25","updated_time":1648290625,"table_pre":"丰网速运_11"},{"cpid":"12","shipping_company":"邮政快递包裹","status":0,"update_admin":"","updated_at":"","updated_time":0,"table_pre":"邮政快递包裹_12"},{"cpid":"13","shipping_company":"天天快递","status":0,"update_admin":"","updated_at":"","updated_time":0,"table_pre":"天天快递_13"},{"cpid":"14","shipping_company":"极兔","status":0,"update_admin":"","updated_at":"","updated_time":0,"table_pre":"极兔_14"}],"update_admin":"刘继明杭州","updated_at":"2022-03-26 18:30:25","圆通_1":1,"申通_2":1,"顺丰_3":1,"韵达_4":1,"中通_5":1,"其他_8":1,"百世_9":1,"EMS_10":1,"丰网速运_11":1,"邮政快递包裹_12":0,"天天快递_13":0,"极兔_14":0}]',
      },
      total: { type: "integer", description: "1" },
    },
    additionalProperties: false,
  },
  requestFunctionName: "getWavePickingShippingConnectList",
  extraInfo: {},
};
/**
 * 接口 [物流联通表,获取列表↗](http://yapi.yishou.com/project/128/interface/api/33308) 的 **请求函数**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/getWavePickingShippingConnectList`
 * @更新时间 `2022-03-29 11:56:15`
 */
export const getWavePickingShippingConnectList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getWavePickingShippingConnectListRequestConfig, requestData),
    ...args
  );
};
getWavePickingShippingConnectList.requestConfig = getWavePickingShippingConnectListRequestConfig;
/**
 * 接口 [获取快递公司排除(联昊通，物流)↗](http://yapi.yishou.com/project/128/interface/api/33309) 的 **请求配置**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/getWavePickingBaseShippingCompany`
 * @更新时间 `2022-03-29 11:53:29`
 */
const getWavePickingBaseShippingCompanyRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePickingShipping/getWavePickingBaseShippingCompany",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: { type: "object", required: [], properties: {} },
  responseDataJsonSchema: {
    type: "array",
    items: {
      type: "object",
      properties: {
        cpid: { type: "string", description: '"1"' },
        shipping_company: { type: "string", description: '"圆通"' },
        table_pre: { type: "string", description: '"圆通_1"' },
      },
      additionalProperties: false,
    },
    description:
      '[{"cpid":"1","shipping_company":"圆通","table_pre":"圆通_1"},{"cpid":"2","shipping_company":"申通","table_pre":"申通_2"},{"cpid":"3","shipping_company":"顺丰","table_pre":"顺丰_3"},{"cpid":"4","shipping_company":"韵达","table_pre":"韵达_4"},{"cpid":"5","shipping_company":"中通","table_pre":"中通_5"},{"cpid":"8","shipping_company":"其他","table_pre":"其他_8"},{"cpid":"9","shipping_company":"百世","table_pre":"百世_9"},{"cpid":"10","shipping_company":"EMS","table_pre":"EMS_10"},{"cpid":"11","shipping_company":"丰网速运","table_pre":"丰网速运_11"},{"cpid":"12","shipping_company":"邮政快递包裹","table_pre":"邮政快递包裹_12"},{"cpid":"13","shipping_company":"天天快递","table_pre":"天天快递_13"},{"cpid":"14","shipping_company":"极兔","table_pre":"极兔_14"}]',
  },
  requestFunctionName: "getWavePickingBaseShippingCompany",
  extraInfo: {},
};
/**
 * 接口 [获取快递公司排除(联昊通，物流)↗](http://yapi.yishou.com/project/128/interface/api/33309) 的 **请求函数**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/getWavePickingBaseShippingCompany`
 * @更新时间 `2022-03-29 11:53:29`
 */
export const getWavePickingBaseShippingCompany = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getWavePickingBaseShippingCompanyRequestConfig, requestData),
    ...args
  );
};
getWavePickingBaseShippingCompany.requestConfig = getWavePickingBaseShippingCompanyRequestConfig;
/**
 * 接口 [物流联通表-批量启用↗](http://yapi.yishou.com/project/128/interface/api/33310) 的 **请求配置**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/setShippingCompanyEnable`
 * @更新时间 `2022-03-26 09:31:33`
 */
const setShippingCompanyEnableRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePickingShipping/setShippingCompanyEnable",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["region_ids", "origin_id", "cpid"],
    properties: {
      region_ids: { type: "string", description: "地区id,多个逗好隔开" },
      origin_id: { type: "string", description: "仓区id" },
      cpid: { type: "string", description: "快递公司id" },
    },
  },
  responseDataJsonSchema: { type: "object" },
  requestFunctionName: "setShippingCompanyEnable",
  extraInfo: {},
};
/**
 * 接口 [物流联通表-批量启用↗](http://yapi.yishou.com/project/128/interface/api/33310) 的 **请求函数**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/setShippingCompanyEnable`
 * @更新时间 `2022-03-26 09:31:33`
 */
export const setShippingCompanyEnable = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(setShippingCompanyEnableRequestConfig, requestData),
    ...args
  );
};
setShippingCompanyEnable.requestConfig = setShippingCompanyEnableRequestConfig;
/**
 * 接口 [物流联通表-批量停发↗](http://yapi.yishou.com/project/128/interface/api/33311) 的 **请求配置**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/setShippingCompanyDisable`
 * @更新时间 `2022-03-26 09:33:06`
 */
const setShippingCompanyDisableRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePickingShipping/setShippingCompanyDisable",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["region_ids", "origin_id", "cpid"],
    properties: {
      region_ids: { type: "string", description: "地区id,多个都好隔开" },
      origin_id: { type: "string", description: "仓区id" },
      cpid: { type: "string", description: "快递公司id" },
    },
  },
  responseDataJsonSchema: { type: "object" },
  requestFunctionName: "setShippingCompanyDisable",
  extraInfo: {},
};
/**
 * 接口 [物流联通表-批量停发↗](http://yapi.yishou.com/project/128/interface/api/33311) 的 **请求函数**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/setShippingCompanyDisable`
 * @更新时间 `2022-03-26 09:33:06`
 */
export const setShippingCompanyDisable = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(setShippingCompanyDisableRequestConfig, requestData),
    ...args
  );
};
setShippingCompanyDisable.requestConfig = setShippingCompanyDisableRequestConfig;
/**
 * 接口 [快递时效表↗](http://yapi.yishou.com/project/128/interface/api/33312) 的 **请求配置**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/getShippingCompanyEfficiency`
 * @更新时间 `2022-03-29 11:57:42`
 */
const getShippingCompanyEfficiencyRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePickingShipping/getShippingCompanyEfficiency",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["origin_id", "page", "pageSize", "is_excel"],
    properties: {
      origin_id: { type: "string", description: "仓区id" },
      page: { type: "string", description: "页码" },
      pageSize: { type: "string", description: "每页加载数量" },
      is_excel: { type: "string", description: "是否导出\t默认=0, 1=是 0=否" },
    },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            region_key: { type: "string", description: '"4153_0_0"' },
            province_region_id: { type: "string", description: '"4153"' },
            city_region_id: { type: "integer" },
            area_region_id: { type: "integer" },
            whole_name: { type: "string", description: '"测试省"' },
            standard_time: { type: "string", description: '"48"' },
            hs_rate: { type: "string", description: '"96.88"' },
            tolerance_value: { type: "string", description: '"8"' },
            provinceName: { type: "string", description: '"测试省"' },
            cityName: { type: "string" },
            areaName: { type: "string" },
            shippingCompanyEfficiency: {
              type: "array",
              items: {
                type: "object",
                properties: {
                  id: { type: "string", description: '"1000000"' },
                  cpid: { type: "string", description: '"1"' },
                  shipping_company: { type: "string", description: '"圆通"' },
                  standard_value: { type: "string", description: '"86.89"' },
                  table_pre: { type: "string", description: '"圆通_1"' },
                },
                additionalProperties: false,
              },
              description:
                '[{"id":"1000000","cpid":"1","shipping_company":"圆通","standard_value":"86.89","table_pre":"圆通_1"},{"id":"1000001","cpid":"2","shipping_company":"申通","standard_value":"85","table_pre":"申通_2"},{"id":"1000002","cpid":"3","shipping_company":"顺丰","standard_value":"91.22","table_pre":"顺丰_3"},{"id":"1000003","cpid":"4","shipping_company":"韵达","standard_value":"79.22","table_pre":"韵达_4"},{"id":"1000004","cpid":"5","shipping_company":"中通","standard_value":"90.22","table_pre":"中通_5"},{"id":"1000005","cpid":"8","shipping_company":"其他","standard_value":"88.54","table_pre":"其他_8"},{"id":"1000006","cpid":"9","shipping_company":"百世","standard_value":"75.36","table_pre":"百世_9"},{"id":"1000007","cpid":"10","shipping_company":"EMS","standard_value":"95.22","table_pre":"EMS_10"},{"id":"1000008","cpid":"11","shipping_company":"丰网速运","standard_value":"78.36","table_pre":"丰网速运_11"},{"id":"1000009","cpid":"12","shipping_company":"邮政快递包裹","standard_value":"77.29","table_pre":"邮政快递包裹_12"},{"id":"1000010","cpid":"13","shipping_company":"天天快递","standard_value":"85.23","table_pre":"天天快递_13"},{"id":"1000011","cpid":"14","shipping_company":"极兔","standard_value":"99.65","table_pre":"极兔_14"}]',
            },
            圆通_1: { type: "string", description: '"86.89"' },
            申通_2: { type: "string", description: '"85"' },
            顺丰_3: { type: "string", description: '"91.22"' },
            韵达_4: { type: "string", description: '"79.22"' },
            中通_5: { type: "string", description: '"90.22"' },
            其他_8: { type: "string", description: '"88.54"' },
            百世_9: { type: "string", description: '"75.36"' },
            EMS_10: { type: "string", description: '"95.22"' },
            丰网速运_11: { type: "string", description: '"78.36"' },
            邮政快递包裹_12: { type: "string", description: '"77.29"' },
            天天快递_13: { type: "string", description: '"85.23"' },
            极兔_14: { type: "string", description: '"99.65"' },
          },
          additionalProperties: false,
        },
        description:
          '[{"region_key":"4153_0_0","province_region_id":"4153","city_region_id":0,"area_region_id":0,"whole_name":"测试省","standard_time":"48","hs_rate":"96.88","tolerance_value":"8","provinceName":"测试省","cityName":"","areaName":"","shippingCompanyEfficiency":[{"id":"1000000","cpid":"1","shipping_company":"圆通","standard_value":"86.89","table_pre":"圆通_1"},{"id":"1000001","cpid":"2","shipping_company":"申通","standard_value":"85","table_pre":"申通_2"},{"id":"1000002","cpid":"3","shipping_company":"顺丰","standard_value":"91.22","table_pre":"顺丰_3"},{"id":"1000003","cpid":"4","shipping_company":"韵达","standard_value":"79.22","table_pre":"韵达_4"},{"id":"1000004","cpid":"5","shipping_company":"中通","standard_value":"90.22","table_pre":"中通_5"},{"id":"1000005","cpid":"8","shipping_company":"其他","standard_value":"88.54","table_pre":"其他_8"},{"id":"1000006","cpid":"9","shipping_company":"百世","standard_value":"75.36","table_pre":"百世_9"},{"id":"1000007","cpid":"10","shipping_company":"EMS","standard_value":"95.22","table_pre":"EMS_10"},{"id":"1000008","cpid":"11","shipping_company":"丰网速运","standard_value":"78.36","table_pre":"丰网速运_11"},{"id":"1000009","cpid":"12","shipping_company":"邮政快递包裹","standard_value":"77.29","table_pre":"邮政快递包裹_12"},{"id":"1000010","cpid":"13","shipping_company":"天天快递","standard_value":"85.23","table_pre":"天天快递_13"},{"id":"1000011","cpid":"14","shipping_company":"极兔","standard_value":"99.65","table_pre":"极兔_14"}],"圆通_1":"86.89","申通_2":"85","顺丰_3":"91.22","韵达_4":"79.22","中通_5":"90.22","其他_8":"88.54","百世_9":"75.36","EMS_10":"95.22","丰网速运_11":"78.36","邮政快递包裹_12":"77.29","天天快递_13":"85.23","极兔_14":"99.65"}]',
      },
      total: { type: "integer", description: "4155" },
    },
    additionalProperties: false,
  },
  requestFunctionName: "getShippingCompanyEfficiency",
  extraInfo: {},
};
/**
 * 接口 [快递时效表↗](http://yapi.yishou.com/project/128/interface/api/33312) 的 **请求函数**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/getShippingCompanyEfficiency`
 * @更新时间 `2022-03-29 11:57:42`
 */
export const getShippingCompanyEfficiency = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getShippingCompanyEfficiencyRequestConfig, requestData),
    ...args
  );
};
getShippingCompanyEfficiency.requestConfig = getShippingCompanyEfficiencyRequestConfig;
/**
 * 接口 [快递时效表-导入↗](http://yapi.yishou.com/project/128/interface/api/33313) 的 **请求配置**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/importShippingCompanyEfficiency`
 * @更新时间 `2022-03-26 09:37:05`
 */
const importShippingCompanyEfficiencyRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePickingShipping/importShippingCompanyEfficiency",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["origin_id", "excel"],
    properties: {
      origin_id: { type: "string", description: "仓区id" },
      excel: { type: "file", description: "上传文件", tsType: "FileData" },
    },
  },
  responseDataJsonSchema: { type: "object" },
  requestFunctionName: "importShippingCompanyEfficiency",
  extraInfo: {},
};
/**
 * 接口 [快递时效表-导入↗](http://yapi.yishou.com/project/128/interface/api/33313) 的 **请求函数**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/importShippingCompanyEfficiency`
 * @更新时间 `2022-03-26 09:37:05`
 */
export const importShippingCompanyEfficiency = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(importShippingCompanyEfficiencyRequestConfig, requestData),
    ...args
  );
};
importShippingCompanyEfficiency.requestConfig = importShippingCompanyEfficiencyRequestConfig;
/**
 * 接口 [快递时效表-查看日志↗](http://yapi.yishou.com/project/128/interface/api/33314) 的 **请求配置**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/getImportShippingCompanyLogList`
 * @更新时间 `2022-03-26 09:39:51`
 */
const getImportShippingCompanyLogListRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePickingShipping/getImportShippingCompanyLogList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["origin_id", "page", "pageSize"],
    properties: {
      origin_id: { type: "string", description: "仓库id" },
      page: { type: "string", description: "页码" },
      pageSize: { type: "string", description: "每页加载量" },
    },
  },
  responseDataJsonSchema: {
    type: "array",
    items: {
      type: "object",
      properties: {
        id: { type: "string", description: '"1"' },
        update_admin: { type: "string", description: '"雅木茶"' },
        stock_storehouse_id: { type: "string", description: '"1"' },
        cpid: { type: "string", description: '"0"' },
        type: { type: "string", description: '"1"' },
        file_url: {
          type: "string",
          description:
            '"/home/ange/web/developer-docker/www/erp/runtime/export/csv-202203241427074459.csv"',
        },
        created_at: { type: "string", description: '"2022-03-24 18:07:10"' },
        updated_at: { type: "string", description: '"2022-03-24 18:07:48"' },
      },
      additionalProperties: false,
    },
    description:
      '[{"id":"1","update_admin":"雅木茶","stock_storehouse_id":"1","cpid":"0","type":"1","file_url":"/home/ange/web/developer-docker/www/erp/runtime/export/csv-202203241427074459.csv","created_at":"2022-03-24 18:07:10","updated_at":"2022-03-24 18:07:48"}]',
  },
  requestFunctionName: "getImportShippingCompanyLogList",
  extraInfo: {},
};
/**
 * 接口 [快递时效表-查看日志↗](http://yapi.yishou.com/project/128/interface/api/33314) 的 **请求函数**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @请求头 `POST /erp/WavePickingShipping/getImportShippingCompanyLogList`
 * @更新时间 `2022-03-26 09:39:51`
 */
export const getImportShippingCompanyLogList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getImportShippingCompanyLogListRequestConfig, requestData),
    ...args
  );
};
getImportShippingCompanyLogList.requestConfig = getImportShippingCompanyLogListRequestConfig;
/**
 * 接口 [快递费率表-列表↗](http://yapi.yishou.com/project/128/interface/api/33319) 的 **请求配置**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @标签 `快递优选一期`
 * @请求头 `POST /erp/wavePickingShipping/rateList`
 * @更新时间 `2022-03-31 14:43:26`
 */
const rateListRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/wavePickingShipping/rateList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["cpid", "stock_storehouse_id", "page"],
    properties: {
      cpid: { type: "string", description: "快递公司id" },
      stock_storehouse_id: { type: "string", description: "仓库id" },
      page: { type: "string", description: "页码" },
      is_excel: { type: "string", description: "是否导出{1:是,0:否}" },
    },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            "1": { type: "string", description: '"陕西省"' },
            "2": { type: "string", description: '"铜川市"' },
            "3": { type: "string" },
            "4": { type: "string", description: '"999.99"' },
            "5": { type: "string", description: '"999.99"' },
            "6": { type: "string", description: '"999.99"' },
            "7": { type: "string", description: '"999.99"' },
            "8": { type: "string", description: '"999.99"' },
            "9": { type: "string", description: '"0.00"' },
            "10": { type: "string", description: '"999.99"' },
            "11": { type: "string", description: '"123"' },
            "12": { type: "string", description: '"1、首重+实际重量*续重"' },
          },
          additionalProperties: false,
        },
        description:
          '[{"1":"陕西省","2":"铜川市","3":"","4":"999.99","5":"999.99","6":"999.99","7":"999.99","8":"999.99","9":"0.00","10":"999.99","11":"123","12":"1、首重+实际重量*续重"}]',
      },
      header: {
        type: "array",
        items: {
          type: "object",
          properties: {
            lable: { type: "string" },
            columns: {
              type: "array",
              items: {
                type: "object",
                properties: {
                  label: { type: "string", description: '"省"' },
                  prop: { type: "string", description: '"1"' },
                },
                additionalProperties: false,
              },
              description:
                '[{"label":"省","prop":"1"},{"label":"市","prop":"2"}]',
            },
          },
          additionalProperties: false,
        },
        description:
          '[{"lable":"","columns":[{"label":"省","prop":"1"},{"label":"市","prop":"2"}]},{"lable":"重量区间（单位：克）","columns":[{"label":"区（县）","prop":"3"}]},{"label":"0-500","columns":[{"label":"单票","prop":"4"}]},{"label":"501-1000","columns":[{"label":"单票","prop":"5"}]},{"label":"1001-2000","columns":[{"label":"单票","prop":"6"}]},{"label":"2001-3000","columns":[{"label":"单票","prop":"7"}]},{"label":"3001-30000","columns":[{"label":"单票","prop":"8"}]},{"label":"30001-99999","columns":[{"label":"首重","prop":"9"},{"label":"续重","prop":"10"}]},{"lable":"","columns":[{"label":"备注","prop":"11"},{"label":"计算方式","prop":"12"}]}]',
      },
    },
    additionalProperties: false,
  },
  requestFunctionName: "rateList",
  extraInfo: {},
};
/**
 * 接口 [快递费率表-列表↗](http://yapi.yishou.com/project/128/interface/api/33319) 的 **请求函数**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @标签 `快递优选一期`
 * @请求头 `POST /erp/wavePickingShipping/rateList`
 * @更新时间 `2022-03-31 14:43:26`
 */
export const rateList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(rateListRequestConfig, requestData), ...args);
};
rateList.requestConfig = rateListRequestConfig;
/**
 * 接口 [快递费率表-查看日志↗](http://yapi.yishou.com/project/128/interface/api/33322) 的 **请求配置**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @标签 `快递优选一期`
 * @请求头 `POST /erp/WavePickingShipping/rateLog`
 * @更新时间 `2022-03-26 17:03:03`
 */
const rateLogRequestConfig = {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePickingShipping/rateLog",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: "object",
    required: ["cpid", "stock_storehouse_id"],
    properties: {
      cpid: { type: "string", description: "快递id" },
      stock_storehouse_id: { type: "string", description: "仓库id" },
    },
  },
  responseDataJsonSchema: {
    type: "object",
    properties: {
      list: {
        type: "array",
        items: {
          type: "object",
          properties: {
            id: { type: "string", description: '"2"' },
            update_admin: { type: "string", description: '"刘继明"' },
            stock_storehouse_id: { type: "string", description: '"1"' },
            cpid: { type: "string", description: '"1"' },
            type: { type: "string", description: '"2"' },
            file_url: {
              type: "string",
              description:
                '"https://img4.yishouapp.com/obs/shippingCompanyImportLog_1/log/2/202203/26/1648284629623ed3d51f935.csv"',
            },
            created_at: {
              type: "string",
              description: '"2022-03-26 16:50:47"',
            },
            updated_at: {
              type: "string",
              description: '"2022-03-26 16:50:47"',
            },
          },
          additionalProperties: false,
        },
        description:
          '[{"id":"2","update_admin":"刘继明","stock_storehouse_id":"1","cpid":"1","type":"2","file_url":"https://img4.yishouapp.com/obs/shippingCompanyImportLog_1/log/2/202203/26/1648284629623ed3d51f935.csv","created_at":"2022-03-26 16:50:47","updated_at":"2022-03-26 16:50:47"}]',
      },
    },
    additionalProperties: false,
  },
  requestFunctionName: "rateLog",
  extraInfo: {},
};
/**
 * 接口 [快递费率表-查看日志↗](http://yapi.yishou.com/project/128/interface/api/33322) 的 **请求函数**
 *
 * @分类 [快递优选↗](http://yapi.yishou.com/project/128/interface/api/cat_3041)
 * @标签 `快递优选一期`
 * @请求头 `POST /erp/WavePickingShipping/rateLog`
 * @更新时间 `2022-03-26 17:03:03`
 */
export const rateLog = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(rateLogRequestConfig, requestData), ...args);
};
rateLog.requestConfig = rateLogRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/wavePickingShipping.js